import { Group, Text } from '@mantine/core';
import { CircleCheckBig } from 'lucide-react';
import type { FC } from 'react';
import { useHostContext } from '@/srcV2/context/HostContext.tsx';

type InformationBlockProps = {
	color?: string;
};

const InformationBlock: FC<InformationBlockProps> = ({ color = '#9CA3AF' }) => {
	const { localization } = useHostContext();
	const resolvedFeatures = [
		localization.translate(
			'vibeCreator',
			'createNewAIReceptionist.featureItems.inboundCalls247'
		),
		localization.translate(
			'vibeCreator',
			'createNewAIReceptionist.featureItems.outboundCalls'
		),
		localization.translate(
			'vibeCreator',
			'createNewAIReceptionist.featureItems.websiteAiChatbot'
		),
		localization.translate(
			'vibeCreator',
			'createNewAIReceptionist.featureItems.agentsCreated'
		),
		localization.translate(
			'vibeCreator',
			'createNewAIReceptionist.featureItems.leaderInReliability'
		)
	];

	return (
		<div className="mb-8 flex flex-wrap justify-center gap-x-10 gap-y-3">
			{resolvedFeatures.map((feature, index) => (
				<Group
					align="center"
					data-testid={`information-block-item-${index}`}
					gap="xs"
					key={feature}
					wrap="nowrap"
				>
					<CircleCheckBig
						color={color}
						size={14}
					/>

					<Text
						className="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-normal leading-5"
						data-testid={`information-block-item-text-${index}`}
					>
						{feature}
					</Text>
				</Group>
			))}
		</div>
	);
};

export default InformationBlock;
